import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatTableModule } from '@angular/material/table';
import { BaseDto } from '@models/base/baseDto.model';
import { AccionesDialog } from '@models/base/identificadores.model';
import { ContactoDto } from '@models/contacto/contactoDto.model';
import { TareaFilter } from '@models/tarea/tareaFilter.model';
import { ContactoService } from '@services/contacto/contacto.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { DialogDeleteComponent } from 'src/app/component/dialog-delete/dialog-delete.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';
import { MovimientoExpedienteService } from '@services/movimientoExpediente/movimientoExpediente.service';
import { MovimientoExpedienteDto } from '@models/movimientoExpediente/movimientoExpedienteDto.model';
import { ButtonNewComponent } from 'src/app/component/button-new/button-new.component';
import { SinDatosParaMostrarComponent } from 'src/app/component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { MovimientoExpedienteFilter } from '@models/movimientoExpediente/movimientoExpedienteFilter.model';
import { ButtonFilterTableComponent } from 'src/app/component/button-filter-table/button-filter-table.component';
import { ButtonFilterTableClearComponent } from 'src/app/component/button-filter-table-clear/button-filter-table-clear.component';
import { EstadoMovimientoExpedienteService } from '@services/estadoMovimientoExpediente/estadoMovimientoExpediente.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DialogFormMovimientoExpedienteComponent } from '../dialog-form-movimiento-expediente/dialog-form-movimiento-expediente.component';
import { DialogParams } from 'src/app/interfaces/dialogParam.interface.model';
import { A11yModule } from '@angular/cdk/a11y';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { EtiquetasPipe } from '@pipes/etiquetas.pipe';
import { BuscarExpedienteComponent } from '@views/busquedas/buscar-expediente/buscar-expediente.component';
import { AvatarInicialesComponent } from 'src/app/component/avatar-iniciales/avatar-iniciales.component';
import { SelectUsuariosEmpresaComponent } from 'src/app/component/select-usuarios-empresa/select-usuarios-empresa.component';

@Component({
  standalone: true,
  imports: [SinDatosParaMostrarComponent, ButtonNewComponent, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule,
    MatDividerModule, NgxSpinnerModule, MatTableModule,
    MatSliderModule, MatSlideToggleModule, MatMenuModule,
    MatDialogModule, MatDatepickerModule, MatExpansionModule,
    FormsModule, AppRolesDirective, MatTooltipModule, MatSortModule,
    MatPaginatorModule, MatRippleModule, CommonModule, ButtonFilterTableComponent, MatNativeDateModule, MatSelectModule, MatRadioModule, A11yModule, MatCheckboxModule, BuscarExpedienteComponent, ButtonFilterTableClearComponent,SelectUsuariosEmpresaComponent],
  selector: 'app-list-movimiento-expediente',
  templateUrl: './list-movimiento-expediente.component.html',
  styleUrls: ['./list-movimiento-expediente.component.css'],
})
export class ListMovimientoExpedienteComponent {

  accionesDialog = AccionesDialog;
  @Input() idExpediente!: number
  data = false
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<MovimientoExpedienteDto>();
  formBuilder = new FormBuilder
  formFilter: FormGroup;
  checkedFiltroAvanzado: boolean = false;
  filtro: MovimientoExpedienteFilter = new MovimientoExpedienteFilter;
  filtroMovimientoExpedienteGuardado!: string | null;
  estadosMovimientoExpediente!: BaseDto[];
  constructor(
    private movimientoExpedienteService: MovimientoExpedienteService,
    private estadoMovimientoExpedienteService: EstadoMovimientoExpedienteService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private dialog: MatDialog
  ) {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      if (this.idExpediente) {
        this.displayedColumns = result.matches
          ? ["expediente", "descripcion", "accion"]
          : ["expediente", "descripcion", "estadoMovimientoExpediente", "fecha", "estados", "accion"];
      } else {
        this.displayedColumns = result.matches
          ? ["descripcion", "accion"]
          : ["descripcion", "estadoMovimientoExpediente", "fecha", "estados", "accion"];
      }
    });

    this.formFilter = this.formBuilder.group({
      Expediente: [''],
      Descripcion: [''],
      IdsEstadoMovimientoExpediente: [''],
      FechaDesde: [null],
      FechaHasta: [null],
      FechaAltaDesde: [null],
      FechaAltaHasta: [null],
      IdExpediente: [null],
      ContenidoEscrito: [null],
      TituloArchivo: [null],
      IdArchivo: [null],
      IdEscrito: [null],
      EsConArchivo: [false],
      EsConEscrito: [false],
    })
  }

  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;
  private paginator!: MatPaginator;
  private sort!: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  ngOnInit(): void {
    this.getAllEstadoMovimientoExpediente();

    if (this.idExpediente) {
      this.formFilter.controls['IdExpediente'].setValue(this.idExpediente);
      this.guardarFiltro()
      this.aplicarFiltro()
    }

    this.filtroMovimientoExpedienteGuardado = localStorage.getItem('filtroMovimientoExpedienteGuardado');
    if (this.filtroMovimientoExpedienteGuardado) {
      this.filtro = JSON.parse(this.filtroMovimientoExpedienteGuardado);
      this.formFilter.patchValue(this.filtro);
    }
  }

  filtrosAvanzados(event: any) {
    if (event.checked == true)
      this.checkedFiltroAvanzado = true
    else
      this.checkedFiltroAvanzado = false
  }

  guardarFiltro() {
    this.filtro = this.formFilter.value;
    localStorage.setItem('filtroMovimientoExpedienteGuardado', JSON.stringify(this.filtro));
  }


  limpiarFiltro() {
    this.formFilter.reset();
    localStorage.removeItem('filtroMovimientoExpedienteGuardado');
  }

  aplicarFiltro(filtro: MovimientoExpedienteFilter = this.formFilter.value) {

    this.getAllByFilter(filtro);
    this.guardarFiltro();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  getAllByIdExpedienteFilter(idExpediente: number) {
    this.spinner.show('spListado')
    this.movimientoExpedienteService.getAllByIdExpediente(idExpediente)
      .subscribe(
        data => {
          this.spinner.hide('spListado')
          this.dataSource.data = data
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide('spListado')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllByFilter(filtro: MovimientoExpedienteFilter) {
    this.spinner.show('spListado')
    this.movimientoExpedienteService.getAllByFilter(filtro)
      .subscribe(
        data => {
          this.spinner.hide('spListado')
          this.dataSource.data = data
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide('spListado')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllEstadoMovimientoExpediente() {
    this.spinner.show('spEstadosMovimientoExpediente')
    this.estadoMovimientoExpedienteService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spEstadosMovimientoExpediente')
          this.estadosMovimientoExpediente = data
        },
        error => {
          this.spinner.hide('spEstadosMovimientoExpediente')
          this.snackBar.showError(error, "Error");
        })
  }

  openDialog<T>(params: DialogParams<T>) {
    const { accion, entidad } = params;

    const data = {
      ...entidad,
      accion,
      idExpediente: this.idExpediente
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false
    dialogConfig.width = "50%"
    dialogConfig.data = data

    const dialogRef = this.dialog.open(DialogFormMovimientoExpedienteComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.event) return;

      switch (result.event) {
        case AccionesDialog.Agregar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Modificar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Eliminar:
          this.aplicarFiltro()
          break;
        default:

          break;
      }

    });
  }

  isFalsy(valor: any) {
    return isFalsy(valor)
  }

  trackByItems(index: number, item: any): any { return item; }
}
